import angular from 'angular';

// NOTE(ed): This abstraction hasn't been thought out. It's only used in one place right now.

// onChange is a callback expected to take a state param.
// An example of an onChange handler is handleSwitchChange = (state) => this.state = state;

// By default, leftValue is false and rightValue is true,
// and false shows up as "No", true shows up as "Yes" by default.
// To override the description, pass a template by transclusion using the switchLeftButton and
// switchRightButton slots.
module.exports = angular.module('common.components.od-three-state-switch', [
])
.component('odThreeStateSwitch', {
  transclude: {
    left: '?switchLeftButton',
    right: '?switchRightButton',
  },
  bindings: {
    leftValue: '<?',
    rightValue: '<?',
    nullable: '<?',
    state: '<?',
    onChange: '&?',
  },
  template: require('./od-three-state-switch.jade')(),
  controller: class {
    $onChanges() {
      this.leftValueOrDefault = this.leftValue === undefined
        ? false : this.leftValue;
      this.rightValueOrDefault = this.rightValue === undefined
        ? true : this.rightValue;

      this.isLeftOn = this.leftValueOrDefault === this.state;
      this.isRightOn = this.rightValueOrDefault === this.state;

      this.leftDescription = this.leftValueOrDefault === true
        ? 'Yes' : this.leftValueOrDefault === false
        ? 'No' : this.leftValue;
      this.rightDescription = this.rightValueOrDefault === true
        ? 'Yes' : this.rightValueOrDefault === false
        ? 'No' : this.rightValue;
    }

    handleClickLeft() {
      if (this.nullable && this.isLeftOn) {
        this.onChange({ state: null });
      } else {
        this.onChange({ state: this.leftValueOrDefault });
      }
    }

    handleClickRight() {
      if (this.nullable && this.isRightOn) {
        this.onChange({ state: null });
      } else {
        this.onChange({ state: this.rightValueOrDefault });
      }
    }
  },
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/od-three-state-switch.js
 **/